import request from '@/axios/index.js'
const uri = '/user/communal/';

export function systemDate(data) {
    return request.axios({
        url: uri+'sys/date'
    })
}


// WEBPACK FOOTER //
// ./src/api/communal.js